
(function () {
  var node = document.getElementById(
    'collection-component-1793416138595'
  );

  // 対象の商品一覧がないページでは実行しない
  if (!node || node.dataset.buyInitialized) return;
  node.dataset.buyInitialized = 'true';

  var scriptURL =
    'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

  if (window.ShopifyBuy && window.ShopifyBuy.UI) {
    ShopifyBuyInit();
  } else {
    var script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    document.head.appendChild(script);
    script.onload = ShopifyBuyInit;
  }

  function ShopifyBuyInit() {
    var client = ShopifyBuy.buildClient({
      domain: 'woodfieldleatherstudio.myshopify.com',
      storefrontAccessToken: '692a1b6bfcc06a3900c3f7425bde9cc4'
    });

    ShopifyBuy.UI.onReady(client).then(function (ui) {
      ui.createComponent('collection', {
        id: '271863480500',
        node: node,
        moneyFormat: '%C2%A5%7B%7Bamount_no_decimals%7D%7D',

        options: {
          product: {
            isButton: true,
            buttonDestination: 'onlineStore',

            contents: {
              img: true,
              title: true,
              price: true,
              options: false,
              button: false,
              buttonWithQuantity: false
            },

            styles: {
              product: {
                "cursor": "pointer",

                "@media (max-width: 600px)": {
                  "width": "calc(50% - 12px)",
                  "max-width": "calc(50% - 12px)",
                  "min-width": "0",
                  "margin-left": "12px",
                  "margin-bottom": "28px"
                },

                "@media (min-width: 601px)": {
                  "width": "calc(25% - 20px)",
                  "max-width": "calc(25% - 20px)",
                  "margin-left": "20px",
                  "margin-bottom": "50px"
                }
              }
            }
          },

          productSet: {
            styles: {
              products: {
                "@media (max-width: 600px)": {
                  "margin-left": "-12px"
                },
                "@media (min-width: 601px)": {
                  "margin-left": "-20px"
                }
              }
            }
          }
        }
      });
    });
  }
})();
